<script setup lang="ts">
import { computed, useTemplateRef } from "vue";

import { useTooltip } from "@/composables/useTooltip";

const props = defineProps<{ text: string }>();

const triggerRef = useTemplateRef("trigger");
const tooltip = computed(() => props.text);

useTooltip({ el: triggerRef, tooltip });
</script>

<template>
  <div ref="trigger" class="sticky-note-type-text">
    {{ text }}
  </div>
</template>

<style scoped lang="scss">
@use "@/styles/mixins/utils";
@use "@/styles/mixins/typography";

.sticky-note-type-text {
  @include typography.small;
  @include utils.ellipsis;

  margin-right: auto;
}
</style>
